const THINKING_FALLBACK = "Kem is thinking...";

const withEllipsis = (label: string): string => {
  const trimmed = label.trim();

  if (trimmed.endsWith("...") || trimmed.endsWith("…")) {
    return trimmed;
  }

  return `${trimmed}...`;
};

const parseJsonObject = (raw: string): Record<string, unknown> | null => {
  try {
    const parsed: unknown = JSON.parse(raw);

    if (parsed && !Array.isArray(parsed) && typeof parsed === "object") {
      return parsed as Record<string, unknown>;
    }
  } catch {
    return null;
  }

  return null;
};

/**
 * Turns a raw `thinking:` payload into a short status label for the chat input.
 */
const formatKemThinkingStep = (payload: string): string => {
  const trimmed = payload.trim();

  if (!trimmed) {
    return THINKING_FALLBACK;
  }

  if (trimmed.startsWith("{") || trimmed.startsWith("[")) {
    const parsed = parseJsonObject(trimmed);

    if (parsed) {
      const candidate =
        parsed.message ??
        parsed.status ??
        parsed.text ??
        parsed.step ??
        parsed.thinking;

      if (typeof candidate === "string" && candidate.trim()) {
        return withEllipsis(candidate);
      }
    }
  }

  return withEllipsis(trimmed);
};

export default formatKemThinkingStep;
